export const AcademicExperiencesDataStructure = [
  {
    school: "Universidade Federal de Pernambuco (CIn-UFPE)",
    course: "Bachelor's Degree in Computer Science",
    duration: "JUNE 2013 - JULY 2021",
    description:
      "Bachelor's degree from the Center for Informatics (CIn-UFPE), with strong foundations in computer science, algorithms, data structures, software engineering, and artificial intelligence. Developed hands-on projects, worked in teams, and conducted research in AI and NLP.",
  },
  {
    school: "MOOC at Udemy",
    course: "HashiCorp Certified: Terraform Associate 2023 (prep course)",
    duration: "JAN 2023 - MAY 2023",
    description:
      "Learned most of Terraform functionalities, applying them in AWS while following the course. Created EC2, IAM users and policies, S3 buckets and policies, ELB, CloudFront, RDS, security groups, and more. Also studied sensitive data handling, scalability, configuration management, and state locking.",
  },
  {
    school: "HashiCorp",
    course: "Terraform Associate 003 (Official Certification)",
    duration: "DEC 2023 - DEC 2025",
    description:
      "Official Terraform Associate 003 certification validating practical knowledge of infrastructure as code, state management, modules, workspaces, and best practices when using Terraform in production on cloud providers.",
  },
  {
    school: "MOOC at StationX",
    course: "The Complete Cyber Security Course: Hackers Exposed!",
    duration: "FEB 2022 - FEB 2022",
    description:
      "Developed practical skills to protect against online threats such as hackers, trackers, and malware, including basics of network security, encryption, and privacy tools.",
  },
  {
    school: "University of Washington (Coursera)",
    course: "Machine Learning Foundations: A Case Study Approach",
    duration: "JUN 2020 - AUG 2020",
    description:
      "Reviewed core concepts of machine learning using case studies. Strengthened understanding of supervised and unsupervised learning, model evaluation, and how ML can improve business outcomes.",
  },
  {
    school: "Hong Kong University / Coursera",
    course: "Front-End Web UI Frameworks and Tools",
    duration: "MAR 2020 - OCT 2020",
    description:
      "Reviewed the basics of UI and modern front-end development, covering HTML, CSS, JavaScript, and frameworks such as Bootstrap. Practiced building responsive web interfaces.",
  },
  {
    school: "MOOC at Udemy",
    course: "Spark 3",
    duration: "JAN 2024 - JAN 2024",
    description:
      "Hands-on course covering Apache Spark 3 fundamentals, RDDs, DataFrames, and performance considerations for batch and streaming data workloads.",
  },
  {
    school: "MOOC at Udemy",
    course: "Mastering Data Modeling Fundamentals",
    duration: "FEB 2024 - FEB 2024",
    description:
      "Studied conceptual, logical, and physical data modeling, normalization, dimensional modeling, and best practices for analytics and OLTP databases.",
  },
  {
    school: "MOOC at Udemy",
    course: "Software Architecture & Design of Modern Large Scale Systems",
    duration: "MAR 2024 - MAR 2024",
    description:
      "Focused on software architecture patterns and large-scale system design, including scalability, availability, fault tolerance, and best practices for modern distributed systems.",
  },
  {
    school: "MOOC at Udemy",
    course: "The Complete Hands-On Introduction to Apache Airflow",
    duration: "APR 2024 - APR 2024",
    description:
      "Practical introduction to Apache Airflow for building, scheduling, and monitoring data pipelines with DAGs, operators, and best practices for maintainable workflows.",
  },
  {
    school: "MOOC at Udemy",
    course: "Manual Software Testing: Complete Course with Practical Labs",
    duration: "APR 2024 - APR 2024",
    description:
      "Covered fundamentals of manual software testing, including test planning, test case design, regression testing, and hands-on labs to practice QA techniques.",
  },
];